export default function whenReady() {
    let promiseResolve;
    const promise = new Promise((resolve) => (promiseResolve = resolve));
    return {
        promise,
        resolve: promiseResolve,
    };
}
